import { render, staticRenderFns } from "./funo.vue?vue&type=template&id=64c0d90e&scoped=true&"
import script from "./funo.vue?vue&type=script&lang=js&"
export * from "./funo.vue?vue&type=script&lang=js&"
import style0 from "./funo.vue?vue&type=style&index=0&id=64c0d90e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0d90e",
  null
  
)

export default component.exports